import React from 'react'

const LabTest = () => {
  return (
    <div>LabTest</div>
  )
}

export default LabTest